// extracted by mini-css-extract-plugin
export default {"link":"Href_link__Ov7o6"};